
const initialState = () => ({
    all: [],
})

let removeNotification = function(id, notifications) {
    if ( id != null ) {
        let index = notifications.map( notification => notification.id ).indexOf(id)
        if ( index >= 0 ) {
            notifications.splice(index, 1)
        }
    }
}

const mutations = {
    ADD_NOTIFICATION(state, notification) {
        removeNotification(notification.id, state.all)
        state.all.push(notification)
    },
    REMOVE_NOTIFICATION(state, notification) {
        removeNotification(notification.id, state.all)
        let index = state.all.indexOf(notification)
        if ( index >= 0 ) {
            state.all.splice(index, 1)
        }
    }
}

export default {
    // initialState, // prevent global reset of notifications, they're not personal
    state: initialState(),
    mutations
}



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/notifications.js